<template>
  <div class=''>
    <div class="box">
      <div>
        <div class="submit"
          style="padding: 10px 7px">
          <span style="color: red; font-size: 14px;margin-right:2px;">*</span>
          <span style="color: #646566; font-size: 14px">封面图</span>
        </div>
        <van-uploader v-model="Thematic"
          multiple
          class="imgs"
          :max-count="1"
          :after-read="thematicRead"
          :before-delete="xcDelete"
          :deletable="true" />
      </div>
      <van-cell-group>
        <van-field v-model="datafrom.Title"
          required
          label="标题"
          placeholder="请输入标题" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="datafrom.Summary"
          required
          label="概述"
          placeholder="请输入概述" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="datafrom.RIKindName"
          required
          @click="rIKindStatus = true"
          readonly="readonly"
          label="资讯类别"
          placeholder="请选择资讯类别" />
        <van-popup v-model="rIKindStatus"
          position="bottom"
          get-container="body">
          <van-picker show-toolbar
            :columns="rIKindlist"
            value-key="Name"
            @cancel="rIKindStatus = false"
            @confirm="onRIKindStatus">
          </van-picker>
        </van-popup>
      </van-cell-group>
      <div>
        <div class="contentTitle">
          <div>
            内容
          </div>
          <Editor :value.sync="datafrom.Content"
            style="margin-top:10px;" />
        </div>
      </div>
      <van-cell-group>
        <van-field v-model="datafrom.Remark"
          label="备注"
          placeholder="请输入备注" />
      </van-cell-group>
      <div class="submit"
        style="padding: 10px 7px">
        <span style="color: red; font-size: 14px;margin-right:2px;">*</span>
        <span style="color: #646566; font-size: 14px">状态</span>
      </div>
      <van-radio-group v-model="datafrom.Status"
        direction="horizontal"
        style="padding: 10px 0;">
        <van-radio name="1">启用</van-radio>
        <van-radio name="2">禁用</van-radio>
      </van-radio-group>
    </div>
    <div class="buttons">
      <van-button type="info"
        style=""
        @click="postfrom(1)"
        v-if="!loading">提交</van-button>
      <van-button type="info"
        v-else
        style=""
        loading-text="加载中..."
        loading></van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import Editor from "./Editors/index"; // 富文本编辑器
import config from "@/config";
import Compressor from "compressorjs";
import axios from "axios";
import wx from "weixin-js-sdk";
Vue.use(Toast);
export default {
  components: {
    Editor
  },
  data () {
    return {
      loading: false,
      datafrom: {
        Title: "",
        // RIId: 0,
        Thematic: "",
        Content: "",
        Summary: "",
        RIKind: "",
        RIKindName: "",
        Remark: "",
        Status: "1",
      },
      Thematic: [],
      rIKindlist: [
        { Id: "1", Name: "法律法规" },
        { Id: "2", Name: "新闻资讯" },
        { Id: "3", Name: "养老知识" },
        { Id: "4", Name: "养老动态" },
      ],
      rIKindStatus: false,
      add: '',
      token: '',
    };
  },
  mounted () {
    this.token = this.$route.query.token
    this.add = this.$route.query.add
    console.log(this.add);
    if (this.add != 0) {
      this.getActivityDetail()
    }
  },

  methods: {
    // 获取活动详情
    getActivityDetail () {
      let that = this
      let url = config.apiRequestUrl + '/So/RealInfo/WeGetRealInfo'
      axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.token,
        },
        params: {
          riId: this.add
        }
      }).then((res) => {
        if (res.data.code == 0) {
          that.datafrom = res.data.data;
          //商铺照片
          if (res.data.data.ShopImg != "") {
            this.Thematic = [
              res.data.data.Thematic,
            ];
            var arr = [];
            this.Thematic.forEach(function (imgUrl) {
              arr.push({ url: imgUrl });
            });
            this.Thematic = arr;
            this.datafrom.ShopImg = res.data.data.ShopImg;
          }
          that.datafrom.RIKind = res.data.data.RIKind;
          if (that.datafrom.RIKind == 1) {
            that.datafrom.RIKindName = '法律法规';
          } else if (that.datafrom.RIKind == 2) {
            that.datafrom.RIKindName = '新闻资讯';
          } else if (that.datafrom.RIKind == 3) {
            that.datafrom.RIKindName = '养老知识';
          } else if (that.datafrom.RIKind == 4) {
            that.datafrom.RIKindName = '养老动态';
          }
          that.datafrom.Status = res.data.data.Status + '';
        }

      })
    },
    //上传封面图
    thematicRead (file) {
      var that = this;
      file.status = "uploading";
      file.message = "上传中...";
      new Compressor(file.file, {
        quality: 0.5,
        success (result) {
          var formData = new FormData();
          let c = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          //构造一个 FormData，把后台需要发送的参数添加
          formData.append("file", result, result.name);
          axios.post('https://ymzhyl.anluoyun.cn/prod-api/upload/uploadImage', formData, c).then((res) => {
            if (res.data.code === 200) {
              console.log(res.data.data.url);
              that.datafrom.Thematic = res.data.data.url;
              // that.datafrom.EvalImgs.push(res.data.data);
              file.status = "";
              file.message = "";
            } else {
              Toast.fail(res.data.msg);
            }
          });
        },
      });
    },
    //删除封面图片
    xcDelete (file) {
      this.Thematic = [];
      this.datafrom.Thematic = "";
    },
    // 选中资讯类别
    onRIKindStatus (val) {
      this.datafrom.RIKind = val.Id;
      this.datafrom.RIKindName = val.Name;
      this.rIKindStatus = false;
    },
    // 提交
    postfrom () {
      // console.log(this.datafrom);
      if (this.datafrom.Thematic == "") {
        Toast.fail("请上传封面图");
        return false;
      }
      if (this.datafrom.Title == "") {
        Toast.fail("请输入标题");
        return false;
      }
      if (this.datafrom.Summary == "") {
        Toast.fail("请输入概述");
        return false;
      }
      if (this.datafrom.RIKind == "") {
        Toast.fail("请选择资讯类别");
        return false;
      }
      this.loading = true
      let c = {
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.token,
        },
      };
      axios.post(config.apiRequestUrl + '/So/RealInfo/SaveRealInfo', this.datafrom, c).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data);
          setTimeout(() => {
            if (window.__wxjs_environment === "miniprogram") {
              window.wx.miniProgram.navigateBack({
                delta: 1,
              });
              this.loading = false
            } else {
              alert('请在小程序中打开')
            }
          }, 1000);
        } else {
          this.loading = false
          Toast.fail(res.data.msg);
        }
      });
    },
  }
}
</script>
<style scoped>
.box {
  width: 92%;
  margin: 10px 3% 100px 3%;
  background: #fff;
  border-radius: 13px;
  padding: 10px 0px;
  box-shadow: 0px 0px 3px rgb(228, 226, 226);
  padding: 10px 1%;
}
.submit {
  padding: 0px 7px;
  float: left;
  width: 6.2em;
}
.contentTitle {
  padding: 10px 16px;
  color: #646566;
  font-size: 14px;
}
.buttons {
  text-align: center;
  width: 95%;
  position: fixed;
  bottom: 0px;
  margin: 10px;
  background: #ffffff;
  padding-bottom: 20px;
  margin-bottom: 0px;
  z-index: 9;
}

.buttons button {
  width: 90%;
  border-radius: 10px;
  background-color: #03a9f4;
  color: #fff;
  border-color: #03a9f4;
  margin: 10px 0;
}
</style>